import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
    align?: 'start' | 'center'
}

const Eyebrow: FC<EyebrowProps> = ({ children, className, align = 'start' }): ReactNode => {
    return (
        <p
            className={cn(
                'inline-flex items-center gap-3 text-[0.7rem] font-medium uppercase tracking-[0.32em] text-gold',
                align === 'center' && 'justify-center',
                className
            )}
        >
            <span aria-hidden='true' className='h-px w-8 bg-linear-to-r from-transparent to-gold/70' />
            {children}
            {align === 'center' && <span aria-hidden='true' className='h-px w-8 bg-linear-to-l from-transparent to-gold/70' />}
        </p>
    )
}

export default Eyebrow
